<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование категории" : "Добавление категории"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='model'
            label='Категория опубликована'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название категории'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("code")'
            :error-messages='errors.first("code")'
            v-model='model.code'
            label='Код категории, может использоваться как часть url'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    model: {}
  }),

  async created() {
    if (this.id===undefined) {
      this.model.published = true
      return
    }
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Shop.Categories' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    _parseResponse(response) {
      try {
        return JSON.parse(response)
      } catch (e) {
        throw e
      }
    },

    vError(index, key) {
      if (this.bErrors[index] && this.bErrors[index][key]) {
        return this.bErrors[index][key]
      }
    },

    ...mapActions('shop/categories', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('shop/categories', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
